export default __webpack_public_path__ + "static/macbook-e49236cc99633f0a588998a8bf71af7c.png";